import { Component, OnInit,  } from '@angular/core';
import { MenuItem, SelectItem, MessageService ,SortEvent} from "primeng/api";
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import {CatRutas, AuxJasper, ParametroJasper, Consumos, CatColonias,CatTipoConsumos, CatAnomalias, CatTipoUsos}from "../../entidades/entidades";
import { CatRutasService } from "../../servicios/cat-rutas.service";
import { CatColoniasService } from '../../servicios/cat-colonias.service';
import { CatTipoConsumosService } from '../../servicios/cat-tipo-consumos.service';
import { CatAnomaliasService } from "../../servicios/cat-anomalias.service";
import { CatTipoUsosService } from "app/servicios/cat-tipo-usos.service";
import { FormGroup, FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent implements OnInit {
  inputsGroup: FormGroup;
  muestraMensaje = new MuestraMensaje();
  catRutas: CatRutas[] = [];
  rutaSelected: number[] = [];
  ruta: CatRutas;
  catConsumos: { anio: number }[];
  catColonias: SelectItem[];
  catTipoConsumos: SelectItem [];
  /*fechaIniSelected = '';
  fechaFinSelected = '';*/
  meses: SelectItem [];
  reportesMicro: SelectItem[];
  usuario: SelectItem[];
  auxJasper: AuxJasper;
  display: boolean = false;
  reporteSelected: any;
  catAnomalias: SelectItem[];
  catTipoUsos: SelectItem[];
  metodo: SelectItem[];
  mostrarBotones: number ;

    
  public progressBar: boolean = false;

  constructor(
    private catRutasService: CatRutasService,
    private catColoniasServices: CatColoniasService,
    private CatTipoConsumosService: CatTipoConsumosService,
    private catAnomaliasService: CatAnomaliasService,
    private catTipoUsoService: CatTipoUsosService,
    private formBuilder: FormBuilder,
  ) {
    this.meses = [
      {label: 'SELECCIONA...', value: null},
      {label: 'Enero', value: 1}, {label: 'Febrero', value: 2}, {label: 'Marzo', value: 3}, {label: 'Abril', value: 4},
      {label: 'Mayo', value: 5}, {label: 'Junio', value: 6}, {label: 'Julio', value: 7}, {label: 'Agosto', value: 8},
      {label: 'Septiembre', value: 9}, {label: 'Octubre', value: 10}, {label: 'Noviembre', value: 11}, {label: 'Diciembre', value: 12}
    ];
    this.reportesMicro = [
      {label: 'SELECCIONA...', value: null},
      {label: 'Reporte De Historico De Lecturas', value: 1}, {label: 'Reporte De Facturación Por Ruta', value: 2},
      {label: 'Reporte De Tomas y Observaciones', value: 3}, {label: 'Reporte De Consumo Por Rango De Operaciones', value: 4},
      {label: 'Reporte De Bitacora De Validacion', value: 5}
    ];
    this.usuario = [
      { label: 'SELECCIONA...', value: null}, { label: 'SIN ESTABLECER', value: null}, { label: 'JUBILADO', value: 133}, { label: 'PENSIONADO', value: 134},
      { label: '3RA EDAD', value: 131},{ label: 'VIUDA', value: 137}, { label: 'DISCAPACIDAD', value: 135}, { label: 'EJIDATARIO', value: 138},
      { label: 'EMPLEADOS', value: 142}, { label: 'ZONA MILITAR', value: null} ] ;// estos valores los estoy tomando de la tabla agua_descuentos pero solo tomo su valor para al consultar los reportes
    this.rutaSelected = [];
    this.metodo = [
      { label: 'SELECCIONA...', value: ''}, { label: 'CF', value: 'CF'}, { label: 'CM', value: 'CM'}, { label: 'D', value: 'D'},  { label: 'PR', value: 'PR'}, { label: 'PU', value: 'PU'}
    ]
  }

  ngOnInit(): void {
    this.getCatRutas();
    this.getColonias();
    this.getTipoConsumos();
    this.getAnomalias();
    this.getAllTipoUso();

    this.inputsGroup = this.formBuilder.group({
      cuenta: [null],
      anio_ini: [null],
      anio_fin: [null],
      periodo_ini: [null],
      periodo_fin: [null],
      colonia: [null],
      ruta: [null],
      toma: [null],
      metodo: [null],
      consMax: [null],
      consMin: [null],
      rutas: [null],
      porAnio: [null],
      porMes: [null],
      observacion: [null]
    });
  }

  async getCatRutas() {
    try{
    const datoRetorno =  await this.catRutasService.getAll().toPromise()

    this.catRutas = datoRetorno;
    this.catRutas.unshift({ numRow: null, id: null, descripcion: 'SELECCIONA...', dato: "", fechaCorte: null });
    console.log('rutas: ', this.catRutas);
  }catch (error){
    console.error('Error al obtener las rutas:', error);
  }
}

async getColonias() {
  try {
    const datoRetorno = await this.catColoniasServices.getAll().toPromise();
    this.catColonias = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });
    this.catColonias.unshift({ label: 'SIN COLONIA...', value: null });
    console.log('colonias:', this.catColonias);
    }catch ( error ){
      console.error('Error al obtener las colonias:', error);
  }
}

async getTipoConsumos(){
  try{
    const datoRetorno = await this.CatTipoConsumosService.getAll().toPromise();
    this.catTipoConsumos = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id};
    });
    this.catTipoConsumos.unshift({ label: 'SELECCIONA...', value: null});
    console.log('tipos de consumos:', this.catTipoConsumos);
    }catch (error){
      console.error('Error al obtener los tipos de consumos:', error);
  }
}

async getAnomalias(){
  try {
    const datoRetorno = await this.catAnomaliasService.getAll().toPromise();
    this.catAnomalias = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id};
    });
    this.catAnomalias.unshift({ label: 'SELECCIONA...', value: null});
  } catch (e) {
    if (e.response) throw { message: e.response.data };
    else throw e;
  } finally {
    console.log("Paso por getAllCatAnomalias");
  }
}

async getAllTipoUso() {
  try {
    const datoRetorno = await this.catTipoUsoService.getAll().toPromise();
    this.catTipoUsos = datoRetorno.map((datos) => {
      return { label: datos.descripcion, value: datos.id };
    });

    this.catTipoUsos.unshift({ label: 'SELECCIONA...', value: null });
    console.log('tipoUSos:', datoRetorno);
    console.log('tipos usos: ', this.catTipoUsos);
  } catch (e) {
    if (e.response) throw { message: e.response.data };
    else throw e;
  } finally {
    console.log('Paso Por getAllTipoUso', this.catTipoUsos);
  }
}

onReporteChange(event: any) {
  this.mostrarBotones = this.reporteSelected ? this.reporteSelected.value : '';
}

async imprimeMicro(tipo: string){
  try{
    if (this.reporteSelected == null){
      this.muestraMensaje.error("Seleccione un tipo de reporte para imprimir.", "top", "center");
        return;
    }

    if(tipo === 'pdf'){
      this.display = true;
    }else{
      this.progressBar = true;
    }

     let inputs = this.inputsGroup.value;

    this.auxJasper = new AuxJasper();
    this.auxJasper.JasperReport.tipo = tipo + '';

    let rutas = inputs.rutas;
    let porRutas = rutas ? rutas.map((ruta: any) => ruta.id).join(',') : null;
    let metodos = inputs.metodo;
    let porMetodos = metodos ? metodos.map((metodo: any) => metodo.value).join( ','): null;
    let observaciones =  inputs.observacion;
    let porObser = observaciones ? observaciones.map((observacion: any) => observacion.value).join(',') : null;
    let tomas = inputs.toma;
    let porTomas = tomas ? tomas.map((toma: any) => toma.value).join(',') : null;
    /*let rutaUnica = inputs.ruta.id;*/

    const getValueOrNull = (value: any) => value ? value : '';

    let params = [];
    switch (this.reporteSelected.value){
      case 1:
        this.auxJasper.JasperReport.nombreReporte = '021_Reporte_Historico_Consumos';
        params = [
          { nombre: '_anio_ini', valor: inputs.anio_ini + "" },
          { nombre: '_periodo_ini', valor: inputs.periodo_ini.value + "" },
          { nombre: '_anio_fin', valor: inputs.anio_fin + "" },
          { nombre: '_periodo_fin', valor: inputs.periodo_fin.value + "" },
          { nombre: '_cuenta', valor: inputs.cuenta + "" }
        ];
      break;  
      case 2:
         this.auxJasper.JasperReport.nombreReporte = '023_Reporte_Facturacion';
         params = [
          { nombre: '_anio_ini', valor: inputs.anio_ini + "" },
          { nombre: '_periodo_ini', valor: inputs.periodo_ini.value + "" },
          { nombre: '_anio_fin', valor: inputs.anio_fin + "" },
          { nombre: '_periodo_fin', valor: inputs.periodo_fin.value + "" }, 
          // { nombre: '_toma', valor: getValueOrNull(inputs.toma?.value) + "" },
          // { nombre: '_observacion', valor: getValueOrNull(inputs.observacion?.value) + "" }
         ];
      break
      case 3:
        this.auxJasper.JasperReport.nombreReporte = '025_Reporte_Tomos_Observaciones';
        params = [
          { nombre: '_anio_ini', valor: inputs.anio_ini + "" },
          { nombre: '_periodo_ini', valor: inputs.periodo_ini.value + "" },
          { nombre: '_anio_fin', valor: inputs.anio_fin + "" },
          { nombre: '_periodo_fin', valor: inputs.periodo_fin.value + "" },
          // { nombre: '_toma', valor: porTomas  },
          { nombre: '_colonia', valor: getValueOrNull(inputs.colonia?.value) +"" },
          // { nombre: '_observacion', valor: porObser }
        ];
      break
      case 4:
        this.auxJasper.JasperReport.nombreReporte = '024_Reporte_Historico_Rangos_Consumo';  //LISTO
        params = [
          { nombre: '_anio_ini', valor: inputs.anio_ini + "" },
          { nombre: '_periodo_ini', valor: inputs.periodo_ini.value + "" },
          { nombre: '_anio_fin', valor: inputs.anio_fin + "" },
          { nombre: '_periodo_fin', valor: inputs.periodo_fin.value + "" },
          { nombre: '_consu_ini', valor: inputs.consMin + "" },
          { nombre: '_consu_fin', valor: inputs.consMax + ""}
        ];
      break;
      case 5:
          this.auxJasper.JasperReport.nombreReporte = '022_Reporte_Validacion_Lecturas';
        params = [
          { nombre: '_id_agua_zona',   valor: inputs.ruta.id +""},
          { nombre: '_anio', valor: inputs.porAnio + "" },
          { nombre: '_periodo_parcialidad', valor: inputs.porMes.value + "" }
        ];
     break;
    }

    params.forEach(param => {
      const p = new ParametroJasper();
      p.nombre = param.nombre;
      p.valor = param.valor;
      this.auxJasper.ParametroJasper.push(p);
    });

    if(this.reporteSelected.value === 3 || this.reporteSelected.value === 2){
      if(porRutas != null){
        let rutas = new ParametroJasper();
        rutas.nombre = '_ruta';
        rutas.valor = porRutas;
        this.auxJasper.ParametroJasper.push(rutas);
      }
      if(porMetodos != null){
        let metodos = new ParametroJasper();
        metodos.nombre = '_metodo';
        metodos.valor = porMetodos;
        this.auxJasper.ParametroJasper.push(metodos);
      }
      if(porObser != null){
        let observaciones = new ParametroJasper();
        observaciones.nombre = '_observacion';
        observaciones.valor = porObser;
        this.auxJasper.ParametroJasper.push(observaciones);
      }
      if(porTomas != null){
        let tomas = new ParametroJasper();
        tomas.nombre = '_toma';
        tomas.valor = porTomas;
        this.auxJasper.ParametroJasper.push(tomas);
      }
    }

    if (tipo === 'xlsx'){
      let formato = new ParametroJasper();
      formato.nombre = 'formato';
      formato.valor = 'xlsx';
      this.auxJasper.ParametroJasper.push(formato);
      this.display = false;
    }
    
    
  }catch(error){
    this.muestraMensaje.error('Error al imprimir.', "top", "center");
  }finally{
    this.inputsGroup.reset();
    setTimeout(() =>{
      this.progressBar = false;
    }, 5000)
  }
}


limpiar(){
  this.inputsGroup.reset();
}
}
